export default {"src":"/_next/static/media/glasses.c5189907.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};